import { Component, Input } from '@angular/core';
import { Subject } from 'rxjs';

import { IEventActivity, IEventSettings } from '../shared/interfaces';

@Component({
    selector: 'aza-rws-activities',
    templateUrl: 'activities.component.html',
    standalone: false
})
export class ActivitiesComponent {
    @Input() eventSettings: IEventSettings;
    @Input() showActivitiesList: Subject<void>;

    selectedActivity: IEventActivity;
    visibility: IVisibility = { list: true };
    quickSearchText = '';
    searchTextChanged = new Subject<string>();

    onSearchTextChanged(): void {
        this.searchTextChanged.next(this.quickSearchText);
    }

    onActivitySelected(activity: IEventActivity): void {
        this.selectedActivity = activity;
        this.visibility = { details: true };
    }

    onSwitchToList(): void {
        this.visibility = { list: true };
        window.setTimeout(() => {
            this.showActivitiesList.next();
        });
    }
}

interface IVisibility {
    list?: boolean;
    details?: boolean;
}
